import { NicheFilesFilter, ResponseError } from "@shared/interfaces";
import { NicheFile, NicheFilesSubscription } from "@shared/models/NicheFile";

export enum NicheFilesError {
  getNicheFilesError = "getNicheFilesError",
  getNicheFileError = "getNicheFileError",
}

export type NicheFilesStateType = {
  files: { list: NicheFile[]; total: number } | null;
  file: NicheFile | null;
  filter: NicheFilesFilter;
  countyPrices: Record<number, number> | null;
  subscription: NicheFilesSubscription;
  subscriptions: NicheFilesSubscription[];
  subscriptionsLoaded: boolean;
  errors: {
    [key in NicheFilesError]: ResponseError | null;
  };
};
